import { array, intersect, partial, struct } from 'io-ts/Decoder';

import { Id as MetadataType } from '../../../../transaction/audit-log/log-type/Id';
import { Request as IndefiniteRequest } from '../../../generic/pagination/indefinite/Request';

export const Request = intersect(
	struct({
		pagination: IndefiniteRequest,
	})
)(
	partial({
		filters: partial({
			type: array(MetadataType),
		}),
	})
);
